import type {Widget} from "~/components/reports/widgetSpecific/widgets";
import {WidgetType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/ReportJson";

export function isMultiBarGraphWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.multiBarGraph) {
        throw new Error("62de3025-d7b5-4cae-86aa-a6b08de1f523");
    }

    return (
        widget.chartSeriesDetails?.length >= widget.minMetricSelections &&
        widget.chartSeriesDetails?.length <= widget.maxMetricSelections &&
        widget.selectedDimensions?.length >= widget.minDimensionSelections &&
        widget.selectedDimensions?.length <= widget.maxDimensionSelections
    );
}

export function isStackedBarGraphWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.stackedBarGraph) {
        throw new Error("4cc522b1-9684-498b-977c-8e27e89b97f0");
    }

    return (
        widget.selectedMetrics?.length >= widget.minMetricSelections &&
        widget.selectedMetrics?.length <= widget.maxMetricSelections &&
        widget.selectedDimensions?.length >= widget.minDimensionSelections &&
        widget.selectedDimensions?.length <= widget.maxDimensionSelections &&
        widget.selectedSlicer !== null
    );
}

export function isHorizontalBarGraphWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.horizontalBarGraph) {
        throw new Error("955390eb-389d-4d06-adea-23d03f29c293");
    }

    return (
        widget.chartSeriesDetails?.length >= widget.minMetricSelections &&
        widget.chartSeriesDetails?.length <= widget.maxMetricSelections &&
        widget.selectedDimensions?.length >= widget.minDimensionSelections &&
        widget.selectedDimensions?.length <= widget.maxDimensionSelections
    );
}

export function isLineGraphWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.lineGraph) {
        throw new Error("549e2fd0-35e4-42a7-805a-fbeb356b68f1");
    }

    return (
        widget.chartSeriesDetails?.length >= widget.minMetricSelections &&
        widget.chartSeriesDetails?.length <= widget.maxMetricSelections &&
        widget.selectedDimensions?.length >= widget.minDimensionSelections &&
        widget.selectedDimensions?.length <= widget.maxDimensionSelections
    );
}

export function isNumberTileWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.numberTile) {
        throw new Error("06ec418b-0832-4148-83de-b0405c88b513");
    }

    return widget.selectedMetrics.length >= widget.minMetricSelections && widget.selectedMetrics.length <= widget.maxMetricSelections;
}

export function isPieChartWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.pieChart) {
        throw new Error("19b4dec8-5ef1-4097-9cc6-56c02945f456");
    }

    return (
        widget.selectedMetrics?.length >= widget.minMetricSelections &&
        widget.selectedMetrics?.length <= widget.maxMetricSelections &&
        widget.selectedDimensions?.length >= widget.minDimensionSelections &&
        widget.selectedDimensions?.length <= widget.maxDimensionSelections
    );
}

export function isDonutChartWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.donutChart) {
        throw new Error("abaa7d38-f762-434b-83c0-34fb43506416");
    }

    return (
        widget.selectedMetrics?.length >= widget.minMetricSelections &&
        widget.selectedMetrics?.length <= widget.maxMetricSelections &&
        widget.selectedDimensions?.length >= widget.minDimensionSelections &&
        widget.selectedDimensions?.length <= widget.maxDimensionSelections
    );
}

export function isTextWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.text) {
        throw new Error("aefe9457-5760-4626-bb10-6ebe7be35ea1");
    }

    return false;
}

export function isImageWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.multiBarGraph) {
        throw new Error("40ae20b4-fa36-4ade-883a-77d396f30138");
    }

    return false;
}

export function isTableWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.table) {
        throw new Error("a6fc129e-cabf-4414-8ecd-b02b20f6b0f1");
    }

    return widget.selectedMetrics?.length >= widget.minMetricSelections || widget.selectedDimensions?.length >= widget.minDimensionSelections;
}

export function isProgressBarWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.progressBar) {
        throw new Error("056d1e72-a4ab-4ff6-9d3f-b23ab1ed56ea");
    }

    return widget.selectedMetrics?.length >= widget.minMetricSelections && widget.selectedMetrics?.length <= widget.maxMetricSelections;
}

export function isGaugeWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.gauge) {
        throw new Error("32a6e51a-b88d-4ca3-8c83-2c453c3fc676");
    }

    return widget.selectedMetrics?.length >= widget.minMetricSelections && widget.selectedMetrics?.length <= widget.maxMetricSelections;
}

export function isAreaGraphWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.areaGraph) {
        throw new Error("27075154-2f3f-4d6b-898d-31f5c846a08b");
    }

    return (
        widget.chartSeriesDetails?.length >= widget.minMetricSelections &&
        widget.chartSeriesDetails?.length <= widget.maxMetricSelections &&
        widget.selectedDimensions?.length >= widget.minDimensionSelections &&
        widget.selectedDimensions?.length <= widget.maxDimensionSelections
    );
}

export function isComboChartWidgetComplete(widget: Widget) {
    if (widget.type !== WidgetType.comboChart) {
        throw new Error("27075154-2f3f-4d6b-898d-31f5c846a08b");
    }

    return widget.selectedDimensions?.length >= widget.minDimensionSelections && widget.selectedDimensions?.length <= widget.maxDimensionSelections;
}

export function isCanvasControlComplete(widget: Widget) {
    if (widget.type !== WidgetType.canvasControl) {
        throw new Error("1722448b-2cb3-4124-b090-7f96c8819fe2");
    }

    return widget.canvasControlId !== null;
}
